export enum FieldType {
  TEXT = 'TEXT',
  DATETIME = 'DATETIME'
}
